import { type OrganizationPresentationContentResponse } from '@airship-platform/proposal-presentations-feature/schema';
import { type RxCollection, type RxCollectionCreator } from 'rxdb';
import { identityMigration } from '../../rxdb/utils/collectionDefaults';

// One document per organization, replaced wholesale on each sync — the offline
// source for the presentation sections that have no entity replication
// (financing rates, org terms, FAQs, core values, promos, proposal header
// images) plus the presentation-scoped organization slice.
const orgContentSchema = {
  version: 1,
  primaryKey: 'organizationId',
  type: 'object',
  properties: {
    organizationId: { type: 'string', maxLength: 36 },
    organization: { type: 'object' },
    financingOptions: { type: 'array' },
    currentOrganizationTerms: { type: 'array' },
    faqs: { type: 'array' },
    coreValues: { type: 'array' },
    brandAssets: { type: 'array' },
    promos: { type: 'array' },
    proposalHeaderImages: { type: 'array' },
  },
  required: ['organizationId'],
} as const;

export const orgContentCollections: Record<
  'organization_presentation_content',
  RxCollectionCreator
> = {
  organization_presentation_content: {
    autoMigrate: false,
    schema: orgContentSchema,
    migrationStrategies: {
      1: identityMigration,
    },
  },
};

export type OrganizationPresentationContentDocType =
  OrganizationPresentationContentResponse;

export type OrgContentCollections = {
  organization_presentation_content: RxCollection<OrganizationPresentationContentDocType>;
};
